import { ChangeDetectionStrategy, Component, computed, effect, inject, signal } from '@angular/core';

import { ButtonComponent, ToastType } from '@program-suite/ui';
import { ModalLayoutComponent } from '../../../../../shared/ui-common/src/lib/components/modals/modal-layout/modal-layout.component';
import {
  AgencyFormModel,
  UiAgencyFormComponent,
} from '../../../../../shared/ui-agency-form/src/lib/ui-agency-form/ui-agency-form.component';
import { InviteAgencyUsersREQ, LookupViewModel, LookupStore } from '@program-suite/data-common';
import { UI_FORM_IMPORTS } from '@program-suite/ui';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ModalService } from '@program-suite/ui';
import { UiAgencyUsersFormComponent } from '@program-suite/ui-agency-users-form';
import { AgencySaveREQ } from '@program-suite/data-common';
import { AgencyStore } from '@program-suite/data-common';
import { Router } from '@angular/router';
import { SnackbarComponent } from '@program-suite/ui';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AddAgentViewModel } from '@program-suite/data-common';

@Component({
  selector: 'lib-add-agency-modal',
  imports: [
    ButtonComponent,
    ModalLayoutComponent,
    UiAgencyFormComponent,
    ReactiveFormsModule,
    ...UI_FORM_IMPORTS,
    UiAgencyUsersFormComponent
],
  templateUrl: './add-agency-modal.component.html',
  styleUrl: './add-agency-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddAgencyModalComponent {
  lookupStore = inject(LookupStore);
  agencyStore = inject(AgencyStore);
  private router = inject(Router);
  currentStep = 1;
  initialUserRows = 5;
  title = 'Add Agency';
  subtitle = '';
  agencyId = computed(() => this.agencyStore.id());
  agency = computed(() => {
    const data = this.agencyStore.agency();
    if (data) {
      return {
        ...data,
        name: data.agencyName,
        address1: data.streetAddress,
        address2: data.suite,
        license: data.licenseNumber,
        website: data.websiteUrl,
      } as AgencyFormModel;
    }
    return null;
  });

  form!: FormGroup;
  agencyUsersForm!: FormGroup;

  constructor(private fb: FormBuilder, private modalService: ModalService, private snackBar: MatSnackBar) {
    this.form = this.fb.group({
      agencyForm: [''],
    });
    (this.agencyUsersForm = this.fb.group({})), this.lookupStore.loadLookup('programs');
    this.lookupStore.loadLookup('states');
    this.lookupStore.loadLookup('agencyRoles');
  }

  submitForm() {
    const data = this.form.get('agencyForm')?.value;
    const agency: AgencySaveREQ = {
      agencyName: data.agencyName,
      streetAddress: data.streetAddress,
      suite: data.suite,
      licenseNumber: data.licenseNumber,
      websiteUrl: data.websiteUrl,
      city: data.city,
      state: data.state,
      zipCode: data.zipCode,
      phone: data.phone,
      programIds: data.programIds,
      isActive: data.status === 'Active' ? true : false,
      id: this.agencyId(),
    };

    this.agencyStore.upsertAgency(agency);
    this.currentStep++;
  }

  submitUsersForm(data: { users: AddAgentViewModel[]; agencyId: number }) {
    const invite: InviteAgencyUsersREQ = {
      agencyId: this.agencyId() ?? undefined,
      agents: data.users,
    };
    this.agencyStore
      .inviteUsers(invite)
      .then(() => {
        this.close();
        this.router.navigate([`/agencies`]).then(() => {
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 10000,
            data: {
              title: 'Agency Added',
              toastType: ToastType.Success,
              message: 'The agency has been added and the users have been sent an email invitation.',
            },
          });
        });
      })
      .catch((error) => {
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          data: { toastType: ToastType.Error, title: 'Error Inviting Users', message: error.message },
        });
      });
  }

  close() {
    this.modalService.close();
  }
}
